// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Nc96","head":"ProcedureTableInfo_head__3-5Sa"};